import { z } from 'zod';

export const WorkFeedSelfServiceModalSchema = z.object({
  agree: z.boolean().refine(value => !!value, 'Required'),
});

export type WorkFeedSelfServiceModal = z.infer<
  typeof WorkFeedSelfServiceModalSchema
>;
